import './viewerImage.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import AiComplianceIcon from '../aiComplianceIcon/aiComplianceIcon';


const ViewerImage = ({ source, aiCompliance, name }) => {
    const { t } = useTranslation();

    let viewer = '' as any;
    if (typeof source !== 'undefined') {
        viewer = (
            <img
                alt={name || "thumbnail preview"}
                data-testid={name}
                src={source}
                onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.style.display = 'none';
                    (e.currentTarget.parentNode as HTMLElement).innerHTML = '<div class="no-preview-container"><p class="main-line">' + t('no_preview') + '</p></div>';
            }}
            />
        );
    } else {
        viewer = (
            <div className="no-preview-container">
                <p className="main-line">
                    {t('no_preview')}
                </p>
            </div>
        );
    }

    return (
        <div role="img" className="b-viewer image">
            <AiComplianceIcon aiCompliance={aiCompliance} />
            {viewer}
        </div>
    );
};

export default ViewerImage;
